module.exports = __webpack_public_path__ + "static/media/eventw.d20464a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eventw.png
// module id = 258
// module chunks = 0